let Manager;
let This;

export default class barbarManager {
    constructor(manager){
        Manager = manager;
        This = this;
        Barba.Pjax.start();
        Barba.Prefetch.init();
    }
    init(){

        var PageTransition = Barba.BaseTransition.extend({
            start: function() {
                Promise
                    .all([this.newContainerLoading])
                    .then(this.out.bind(this))
                    .then(this.show.bind(this));
            },
            out: function() {
                return This.out();
            },
            show: function() {

                this.newContainer.style.opacity = 0;
                Manager.status.execution = "trans";

                let _delay = '4e2'; //通常delay

                if(this.oldContainer.getAttribute('data-namespace') == 'concept' && Manager.status.pageID == 'concept_detail'){ //concept一覧から詳細
                    Manager.page.transition.out();
                    _delay = '21e2';
                }else if(this.oldContainer.getAttribute('data-namespace') == 'concept_detail' && Manager.status.pageID == 'concept'){ //concept詳細から一覧
                    Manager.page.transition.detailOut();
                    _delay = '12e2';
                }else if(this.oldContainer.getAttribute('data-namespace') == 'concept_detail' && Manager.status.pageID == 'concept_detail'){ //concept詳細から詳細
                    Manager.page.transition.detailOut();
                    _delay = '14e2';
                }else if(this.oldContainer.getAttribute('data-namespace') == 'scene' && Manager.status.pageID == 'top' || this.oldContainer.getAttribute('data-namespace') == 'concept' && Manager.status.pageID == 'top'){ //sceneからTOP 、concept一覧からTOP
                    Manager.page.transition.out();
                    _delay = '14e2';
                }else if(this.oldContainer.getAttribute('data-namespace') == 'concept_detail' && Manager.status.pageID == 'top'){ //concept詳細からTOP
                    Manager.page.transition.detailOut();
                    _delay = '14e2';
                }

                setTimeout(()=>{

                    document.body.id = Manager.status.pageID;
                    this.oldContainer.style.display = "none";
                    this.newContainer.style.opacity = 1;
                    This.show();
                    this.done();

                    Manager.init();

                },_delay);

            }
        });

        Barba.Dispatcher.on('linkClicked', function(e) {
            let _$link = document.getElementsByTagName('a');
            for(let i in _$link){
                if(_$link[i].nodeType!=1) continue; // dom要素以外は処理止める
                _$link[i].classList.add('no-link');
            }
        });

        Barba.Dispatcher.on('newPageReady', function(currentStatus, prevStatus, HTMLElementContainer, newPageRawHTML) {

            /* ページ情報取得 */
            Manager.status.pageID = currentStatus.namespace;

            /* head内書き換え */
            var head = document.head;
            var newPageRawHead = newPageRawHTML.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0];
            var newPageHead = document.createElement('head');
            newPageHead.innerHTML = newPageRawHead;

            var removeHeadTags = [
                "meta[name='keywords']"
                ,"meta[name='description']"
                ,"meta[property^='og']"
                ,"meta[name^='twitter']"
                ,"meta[itemprop]"
                ,"link[itemprop]"
                ,"link[rel='prev']"
                ,"link[rel='next']"
                ,"link[rel='canonical']"
            ].join(',');

            var headTags = head.querySelectorAll(removeHeadTags)
            for(var i = 0; i < headTags.length; i++ ){
                head.removeChild(headTags[i]);
            }
            var newHeadTags = newPageHead.querySelectorAll(removeHeadTags)

            for(var i = 0; i < newHeadTags.length; i++ ){
                head.appendChild(newHeadTags[i]);
            }
            document.body.classList = "";
            document.body.classList.add("is-asy");

            //アナリティクスに送信
            //ga('send', 'pageview', window.location.pathname.replace(/^\/?/, '/') + window.location.search);

            /* html書き換え */

        });

        Barba.Pjax.getTransition = function() {
            return PageTransition;
        };
        Barba.Dispatcher.on("load", function() {
        });

        //遷移前の処理
        Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;
        Barba.Pjax.preventCheck = function(evt, element) {
            return Barba.Pjax.originalPreventCheck(evt, element)

            if(element){
                if(element.classList.contains('no-barba')) return false;
                if(element.getAttribute("target") === '_blank') return false;
                return Barba.Pjax.originalPreventCheck(evt, element)
            }else{
                return Barba.Pjax.originalPreventCheck(evt, element)
                // return true;
            }
        };

        Barba.Dispatcher.on('linkClicked', (element, event) => {

            //if(!scroll.status.comp) return; //スクロール中は通さない

            // _successURL = element.getAttribute('href');

        });

    }

    show(){

        //menu
        if(Manager.menu.status.open){
            Manager.menu.hide();
        }

    }

    out(){

        Manager.status.transFlg = true;

        TweenMax.set(document.querySelector('.pace'),{
            display:'none',
            ease:Manager.ease,
        });

    }

}
